import { useTranslation } from 'react-i18next';
import Modal from '@lib/components/Modal/Modal';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import ActionsRow from '@lib/components/ActionsRow/ActionsRow';
import { IconName } from '@lib/components/Modal/enums';
import useSessionExpired from '@lib/hooks/useSessionExpired';

export interface SessionExpiredModalProps {
  loginUrl: string;
}

function SessionExpiredModal({ loginUrl }: SessionExpiredModalProps) {
  const { t } = useTranslation();
  const isSessionExpired = useSessionExpired();

  const handleLogIn = () => {
    window.location.href = loginUrl;
  };

  return (
    <Modal
      isOpen={isSessionExpired}
      icon={IconName.Logout}
      title={t('session-expired-title')}
      description={t('session-expired-description')}
      actions={
        <ActionsRow
          actions={[
            <Button
              buttonText={t('log-in')}
              buttonType={ButtonTypes.primaryFilled}
              fullWidth
              onClick={handleLogIn}
            />,
          ]}
        />
      }
    />
  );
}

export default SessionExpiredModal;
